<template>
  <base-form :title="title"
             :loading="submitLoading"
             @submit="submitForm">
    <div v-if="model">
      <fg-input :label="$t('placeholders.key')"
                :placeholder="$t('placeholders.key')"
                :error="getError($t('placeholders.key'))"
                :name="$t('placeholders.key')"
                :disabled="model.id"
                v-model="model.key"
                v-validate="'required'">
      </fg-input>
      <fg-input :label="$t('placeholders.name')"
                :placeholder="$t('placeholders.name')"
                :error="getError($t('placeholders.name'))"
                :name="$t('placeholders.name')"
                :disabled="model.is_default"
                v-model="model.name"
                v-validate="'required'">
      </fg-input>

      <fg-input :label="$t('placeholders.value')"
                :placeholder="$t('placeholders.value')"
                :error="getError($t('placeholders.value'))"
                :name="$t('placeholders.value')"
                :disabled="model.is_default"
                v-model="model.value"
                v-validate="'required'">
      </fg-input>
    </div>
  </base-form>
</template>
<script>

  export default {
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      title: String,
      submitLoading: Boolean,
    },
    data () {
      return {
        model: {
          job_board_id: this.$route.params.id,
          key: '',
          name: '',
          value: '',
        },
      }
    },
    methods: {
      async submitForm () {
        let isFormValid = await this.$validator.validateAll()
        if (!isFormValid) {
          return
        }
        this.$emit('submit', this.model)
      },
    },
    watch: {
      data: {
        immediate: true,
        handler(newVal) {
          if (!newVal || !Object.keys(newVal).length) {
            return
          }
          this.model = {
            ...newVal,
            job_board_id: newVal.job_board_id || this.$route.params.id
          }
        }
      }
    }
  }
</script>
<style>
</style>
